import { Button, ButtonVariant, Text, TextField } from "@merge-api/merge-javascript-shared";
import { Plus, Search } from "lucide-react";
import Logo from "../../../../assets/svg/logo.svg";
import { INTEGRATION_BUILDER_PATH } from "../../../../router/RouterUtils";

type Props = {
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
};

const IntegrationsSearchHero = ({ searchTerm, setSearchTerm }: Props) => {
  // event handlers
  const createIntegration = () => {
    window.open(INTEGRATION_BUILDER_PATH, "_blank");
  };

  // render
  return (
    <div className="flex w-full flex-col items-center">
      <img alt="Merge logo" src={Logo} className="mb-6 h-6" />
      <Text variant="hero" className="mb-3 text-center">
        Find an Integration
      </Text>
      <Text variant="lg" className="mb-8 text-center text-gray-40">
        Search by Integration name, Blueprint ID, or Blueprint version
      </Text>
      <TextField
        className="w-full max-w-xl bg-white"
        type="search"
        placeholder="Search integrations, blueprint ids, and blueprint versions"
        value={searchTerm}
        prefix={<Search className="ml-3" size={16} />}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <Button
        variant={ButtonVariant.TextBlue}
        className="mt-6"
        leftIcon={<Plus size={16} />}
        onClick={createIntegration}
      >
        Create a new Integration
      </Button>
    </div>
  );
};

export default IntegrationsSearchHero;
